// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* AppHeader — fixed top bar across the whole app (desktop + mobile). */

.app-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: var(--app-header-height, 56px);
  z-index: 1100;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 0 16px;
  /* Same purple as the sidebar so the top-left corner where they meet is
     seamless (sidebar's top edge is #4510b0), lightening toward the right. */
  background: linear-gradient(135deg, #4510b0 0%, #5616ea 100%);
  box-sizing: border-box;
  font-family: "DM Sans", sans-serif;
  /* One source of truth for both SVG hairlines: the bottom seam against the
     sidebar (.app-header-seam) and the vertical dividers (.app-header-divider)
     stay the same colour and 1px thickness. */
  --app-header-line-color: rgba(255, 255, 255, 0.22);
}

.app-header-left,
.app-header-right {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}

.app-header-left {
  flex: 1 1 auto;
}

/* ── Logo ──────────────────────────────────────────────────────────── */
.app-header-logo {
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
}
.app-header-logo img {
  height: 26px;
  width: auto;
  display: block;
}

.app-header-divider {
  display: block;
  width: 1px;
  height: 26px;
  /* Fill colour for the SVG rule (fill="currentColor"); shared with the seam. */
  color: var(--app-header-line-color);
  margin: 0 4px;
  flex-shrink: 0;
}

/* Bottom seam — SVG hairline along the header's lower edge (the line against
   the sidebar). Same crispEdges rendering, 1px thickness and colour as the
   vertical dividers. Absolutely positioned within the fixed header. */
.app-header-seam {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 1px;
  display: block;
  color: var(--app-header-line-color);
  pointer-events: none;
}

/* ── Burger (mobile only) ──────────────────────────────────────────── */
.app-header-burger {
  display: none;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  border: none;
  border-radius: 9px;
  background: transparent;
  color: #ffffff;
  font-size: 18px;
  cursor: pointer;
  flex-shrink: 0;
}
.app-header-burger:hover {
  background: rgba(255, 255, 255, 0.15);
}

/* ── Right-side icon buttons ───────────────────────────────────────── */
.app-header-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  border: none;
  border-radius: 9px;
  background: transparent;
  color: rgba(255, 255, 255, 0.85);
  font-size: 17px;
  cursor: pointer;
  text-decoration: none;
  transition: background 0.15s ease, color 0.15s ease;
}
.app-header-icon:hover {
  background: rgba(255, 255, 255, 0.15);
  color: #ffffff;
}

/* ── "Test Agent" button (next to the bot selector) ────────────────────
   Shares the selectors' shape (1px border, 8px radius, same vertical
   padding + gap as \`.bot-selector.header .bot-selector-label\`), but
   reverses the colours into a solid white pill so it reads as a distinct
   call-to-action against the translucent selectors. */
.app-header-test-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 6px 12px;
  border: 1px solid #ffffff;
  border-radius: 8px;
  background: #ffffff;
  color: #5616ea;
  font-family: "DM Sans", sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.4;
  white-space: nowrap;
  cursor: pointer;
  flex-shrink: 0;
  transition: background 0.2s ease, border-color 0.2s ease, color 0.2s ease;
}
.app-header-test-btn:hover {
  background: #f0ebff;
  border-color: #f0ebff;
  color: #4510b0;
}
/* Play glyph sits in a small purple disc so the CTA reads at a glance. */
.app-header-test-btn-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: #5616ea;
  color: #ffffff;
  font-size: 8px;
  /* faPlay's glyph is left-weighted; nudge it to look optically centred. */
  padding-left: 1px;
  flex: 0 0 auto;
  transition: background 0.2s ease;
}
.app-header-test-btn:hover .app-header-test-btn-icon {
  background: #4510b0;
}

@media (max-width: 768px) {
  .app-header {
    padding: 0 10px;
    gap: 6px;
  }
  .app-header-burger {
    display: inline-flex;
  }
  /* On phones the workspace/bot selectors and Test Agent move into the sidebar
     (see AppSidebar), so the header keeps only: burger, logo, help, the grey
     divider, and the account menu. The single remaining divider (before the
     user menu) stays visible — it's the "grey vertical line" in the design. */
  .app-header-icon {
    width: 34px;
    height: 34px;
  }
}

@media (max-width: 520px) {
  .app-header-logo img {
    height: 22px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/AppHeader.css"],"names":[],"mappings":"AAAA,uEAAuE;;AAEvE;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,sCAAsC;EACtC,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf;6EAC2E;EAC3E,6DAA6D;EAC7D,sBAAsB;EACtB,kCAAkC;EAClC;;8CAE4C;EAC5C,kDAAkD;AACpD;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA,yEAAyE;AACzE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,YAAY;EACZ,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,UAAU;EACV,YAAY;EACZ,8EAA8E;EAC9E,mCAAmC;EACnC,aAAa;EACb,cAAc;AAChB;;AAEA;;sEAEsE;AACtE;EACE,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,WAAW;EACX,WAAW;EACX,cAAc;EACd,mCAAmC;EACnC,oBAAoB;AACtB;;AAEA,yEAAyE;AACzE;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,eAAe;EACf,cAAc;AAChB;AACA;EACE,qCAAqC;AACvC;;AAEA,yEAAyE;AACzE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,gCAAgC;EAChC,eAAe;EACf,eAAe;EACf,qBAAqB;EACrB,mDAAmD;AACrD;AACA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;;;;sDAIsD;AACtD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,yEAAyE;AAC3E;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;AACA,yEAAyE;AACzE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,cAAc;EACd,yEAAyE;EACzE,iBAAiB;EACjB,cAAc;EACd,gCAAgC;AAClC;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,eAAe;IACf,QAAQ;EACV;EACA;IACE,oBAAoB;EACtB;EACA;;;8EAG4E;EAC5E;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE;IACE,YAAY;EACd;AACF","sourcesContent":["/* AppHeader — fixed top bar across the whole app (desktop + mobile). */\r\n\r\n.app-header {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  height: var(--app-header-height, 56px);\r\n  z-index: 1100;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 12px;\r\n  padding: 0 16px;\r\n  /* Same purple as the sidebar so the top-left corner where they meet is\r\n     seamless (sidebar's top edge is #4510b0), lightening toward the right. */\r\n  background: linear-gradient(135deg, #4510b0 0%, #5616ea 100%);\r\n  box-sizing: border-box;\r\n  font-family: \"DM Sans\", sans-serif;\r\n  /* One source of truth for both SVG hairlines: the bottom seam against the\r\n     sidebar (.app-header-seam) and the vertical dividers (.app-header-divider)\r\n     stay the same colour and 1px thickness. */\r\n  --app-header-line-color: rgba(255, 255, 255, 0.22);\r\n}\r\n\r\n.app-header-left,\r\n.app-header-right {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  min-width: 0;\r\n}\r\n\r\n.app-header-left {\r\n  flex: 1 1 auto;\r\n}\r\n\r\n/* ── Logo ──────────────────────────────────────────────────────────── */\r\n.app-header-logo {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  flex-shrink: 0;\r\n}\r\n.app-header-logo img {\r\n  height: 26px;\r\n  width: auto;\r\n  display: block;\r\n}\r\n\r\n.app-header-divider {\r\n  display: block;\r\n  width: 1px;\r\n  height: 26px;\r\n  /* Fill colour for the SVG rule (fill=\"currentColor\"); shared with the seam. */\r\n  color: var(--app-header-line-color);\r\n  margin: 0 4px;\r\n  flex-shrink: 0;\r\n}\r\n\r\n/* Bottom seam — SVG hairline along the header's lower edge (the line against\r\n   the sidebar). Same crispEdges rendering, 1px thickness and colour as the\r\n   vertical dividers. Absolutely positioned within the fixed header. */\r\n.app-header-seam {\r\n  position: absolute;\r\n  left: 0;\r\n  bottom: 0;\r\n  width: 100%;\r\n  height: 1px;\r\n  display: block;\r\n  color: var(--app-header-line-color);\r\n  pointer-events: none;\r\n}\r\n\r\n/* ── Burger (mobile only) ──────────────────────────────────────────── */\r\n.app-header-burger {\r\n  display: none;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 38px;\r\n  height: 38px;\r\n  border: none;\r\n  border-radius: 9px;\r\n  background: transparent;\r\n  color: #ffffff;\r\n  font-size: 18px;\r\n  cursor: pointer;\r\n  flex-shrink: 0;\r\n}\r\n.app-header-burger:hover {\r\n  background: rgba(255, 255, 255, 0.15);\r\n}\r\n\r\n/* ── Right-side icon buttons ───────────────────────────────────────── */\r\n.app-header-icon {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 38px;\r\n  height: 38px;\r\n  border: none;\r\n  border-radius: 9px;\r\n  background: transparent;\r\n  color: rgba(255, 255, 255, 0.85);\r\n  font-size: 17px;\r\n  cursor: pointer;\r\n  text-decoration: none;\r\n  transition: background 0.15s ease, color 0.15s ease;\r\n}\r\n.app-header-icon:hover {\r\n  background: rgba(255, 255, 255, 0.15);\r\n  color: #ffffff;\r\n}\r\n\r\n/* ── \"Test Agent\" button (next to the bot selector) ────────────────────\r\n   Shares the selectors' shape (1px border, 8px radius, same vertical\r\n   padding + gap as `.bot-selector.header .bot-selector-label`), but\r\n   reverses the colours into a solid white pill so it reads as a distinct\r\n   call-to-action against the translucent selectors. */\r\n.app-header-test-btn {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  padding: 6px 12px;\r\n  border: 1px solid #ffffff;\r\n  border-radius: 8px;\r\n  background: #ffffff;\r\n  color: #5616ea;\r\n  font-family: \"DM Sans\", sans-serif;\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  line-height: 1.4;\r\n  white-space: nowrap;\r\n  cursor: pointer;\r\n  flex-shrink: 0;\r\n  transition: background 0.2s ease, border-color 0.2s ease, color 0.2s ease;\r\n}\r\n.app-header-test-btn:hover {\r\n  background: #f0ebff;\r\n  border-color: #f0ebff;\r\n  color: #4510b0;\r\n}\r\n/* Play glyph sits in a small purple disc so the CTA reads at a glance. */\r\n.app-header-test-btn-icon {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 18px;\r\n  height: 18px;\r\n  border-radius: 50%;\r\n  background: #5616ea;\r\n  color: #ffffff;\r\n  font-size: 8px;\r\n  /* faPlay's glyph is left-weighted; nudge it to look optically centred. */\r\n  padding-left: 1px;\r\n  flex: 0 0 auto;\r\n  transition: background 0.2s ease;\r\n}\r\n.app-header-test-btn:hover .app-header-test-btn-icon {\r\n  background: #4510b0;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .app-header {\r\n    padding: 0 10px;\r\n    gap: 6px;\r\n  }\r\n  .app-header-burger {\r\n    display: inline-flex;\r\n  }\r\n  /* On phones the workspace/bot selectors and Test Agent move into the sidebar\r\n     (see AppSidebar), so the header keeps only: burger, logo, help, the grey\r\n     divider, and the account menu. The single remaining divider (before the\r\n     user menu) stays visible — it's the \"grey vertical line\" in the design. */\r\n  .app-header-icon {\r\n    width: 34px;\r\n    height: 34px;\r\n  }\r\n}\r\n\r\n@media (max-width: 520px) {\r\n  .app-header-logo img {\r\n    height: 22px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
